import axios from "../../axios";

const getShipmentItemsById = async (id) => {
  try {
    const { data } = await axios.get(`/synced_shipments/items/${id}`);
    return data;
  } catch (e) {
    return null;
  }
}

export { getShipmentItemsById };